import { supabase } from "../supabaseClient"

const invokeMetaPixel = async (body) => {
  const { data, error } = await supabase.functions.invoke("meta-pixel", { body })
  if (error) {
    let message = error.message || "Meta request failed"
    const response = error.context
    if (response?.json) {
      try {
        const errorBody = await response.json()
        message = errorBody?.error || message
      } catch (_) {
        // Keep the function client's error message.
      }
    }
    throw new Error(message)
  }
  if (data?.error) throw new Error(data.error)
  return data || {}
}

export const listMetaPixelConnections = (organizationId) =>
  invokeMetaPixel({ action: "list", organization_id: organizationId })

export const startMetaOAuth = (organizationId) =>
  invokeMetaPixel({
    action: "oauth-start",
    organization_id: organizationId,
  })

export const completeMetaOAuth = (organizationId, code, state) =>
  invokeMetaPixel({
    action: "oauth-complete",
    organization_id: organizationId,
    code,
    state,
  })

export const connectMetaPixel = (organizationId, oauthSessionId, pixel) =>
  invokeMetaPixel({
    action: "connect",
    organization_id: organizationId,
    oauth_session_id: oauthSessionId,
    pixel_id: pixel.id,
    pixel_name: pixel.name,
    ad_account_id: pixel.ad_account_id,
    ad_account_name: pixel.ad_account_name,
    last_fired_time: pixel.last_fired_time,
  })

export const loadMetaPixelEvents = (organizationId, connectionId, days) =>
  invokeMetaPixel({
    action: "events",
    organization_id: organizationId,
    connection_id: connectionId,
    days,
  })

export const runMetaPixelAudit = (organizationId, connectionId, days) =>
  invokeMetaPixel({
    action: "audit",
    organization_id: organizationId,
    connection_id: connectionId,
    days,
  })

export const loadLatestMetaPixelAudit = (organizationId, connectionId) =>
  invokeMetaPixel({
    action: "audit-result",
    organization_id: organizationId,
    connection_id: connectionId,
  })

export const disconnectMetaPixel = (organizationId, connectionId) =>
  invokeMetaPixel({
    action: "disconnect",
    organization_id: organizationId,
    connection_id: connectionId,
  })

